import { Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  ContactFragment,
  contactFragmentString,
} from '../../fragments/__generated__/ContactFragment'

import {
  MinimalContactFragment,
  minimalContactFragmentString,
} from '../../fragments/__generated__/MinimalContactFragment'

import getPaginatedContactsRawString from '../GetPaginatedContacts.graphql'

const getPaginatedContactsString = [
  getPaginatedContactsRawString,
  contactFragmentString,
  minimalContactFragmentString,
].join('\n\n')

export type GetPaginatedContactsData = {
  paginatedContacts: {
    contacts: ContactFragment[]
    allContacts: MinimalContactFragment[]
    count: number
  }
}

export type GetPaginatedContactsVariables = {
  search?: Maybe<string>
  offset?: Maybe<number>
  limit?: Maybe<number>
  contacts?: Maybe<string[]>
  groups?: Maybe<string[]>
  birthdayStartDate?: Maybe<string>
  birthdayEndDate?: Maybe<string>
  anniversaryStartDate?: Maybe<string>
  anniversaryEndDate?: Maybe<string>
  showSecondaryContacts?: Maybe<boolean>
  hasNoGroup?: Maybe<boolean>
}

export type GetPaginatedContacts = Operation<
  GetPaginatedContactsData,
  GetPaginatedContactsVariables
>

export const GetPaginatedContacts = ({
  search,
  offset,
  limit,
  contacts,
  groups,
  birthdayStartDate,
  birthdayEndDate,
  anniversaryStartDate,
  anniversaryEndDate,
  showSecondaryContacts,
  hasNoGroup,
}: GetPaginatedContactsVariables = {}): GetPaginatedContacts => ({
  query: getPaginatedContactsString,
  variables: {
    search,
    offset,
    limit,
    contacts,
    groups,
    birthdayStartDate,
    birthdayEndDate,
    anniversaryStartDate,
    anniversaryEndDate,
    showSecondaryContacts,
    hasNoGroup,
  },
})
